import React, { Component } from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import Home from '../Home';
import UploadGeneric from '../Upload/UploadGeneric';
import * as ROUTES from '../../constants/routes';
import './index.css';

class BrandedWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoLoaded: null, // null = loading, true = success, false = failed
    };
  }

  handleLogoLoad = () => {
    this.setState({ logoLoaded: true });
  };

  handleLogoError = () => {
    this.setState({ logoLoaded: false });
  };

  render() {
    const company = this.props.match.params.company.toLowerCase();
    const logoPath = `/logos/${company}.png`;

    // Redirect to non-branded equivalent if logo doesn't exist
    if (this.state.logoLoaded === false) {
      // Determine where to redirect based on current path
      const currentPath = this.props.location.pathname;
      if (currentPath.includes('/upload')) {
        return <Redirect to="/upload" />;
      }
      return <Redirect to="/" />;
    }

    return (
      <div>
        {/* Hidden image to test if logo exists */}
        <img
          src={logoPath}
          alt=""
          style={{ display: 'none' }}
          onLoad={this.handleLogoLoad}
          onError={this.handleLogoError}
        />

        {/* Logo overlay - fixed position, doesn't affect layout */}
        {this.state.logoLoaded && (
          <div className="company-logo-container">
            <img
              src={logoPath}
              alt={`${company} logo`}
              className="company-logo"
            />
          </div>
        )}

        {/* Render the appropriate content based on route */}
        <Switch>
          <Route exact path={ROUTES.BRANDED_LANDING} component={Home} />
          <Route exact path={ROUTES.BRANDED_UPLOAD} component={BrandedUploadPage} />
          <Route exact path={ROUTES.BRANDED_UPLOADACCESSCODE} component={BrandedUploadPage} />
        </Switch>
      </div>
    );
  }
}

// Wrapper to add the spacer that Upload component has
const BrandedUploadPage = (props) => (
  <div>
    <h1>&nbsp;</h1>
    <UploadGeneric {...props} />
  </div>
);

export default BrandedWrapper;
